import { useEffect, useState } from "react";
import clg from "./log";

function useScrollPosition() {
  const [scrollPostion, setScrollPosition] = useState({ x: 0, y: 0, direction : "downwards"});

  useEffect(() => {
      function onScroll() {
        const prevY = scrollPostion.y;

        const Y = window.pageYOffset;
        const X = window.pageXOffset;

        let direction = "";

        if( prevY < Y ) direction = "downwards";
        else direction = "upwards";

        setScrollPosition({
          ...scrollPostion,
          ["x"]: X,
          ["y"]: Y,
          ["direction"] : direction,
        });
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollPostion]);

  return scrollPostion;
}

export default useScrollPosition;